import React, { useContext } from "react";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import { Typography } from "@mui/material";
import { Stack } from "@mui/system";

import { getRuta, isAccess } from "../../helpers/Helpers";
import { DataContext } from "../../context/DataContext";
import { Configurations } from "./Configurations";
import Security from "./Security";
import Administracion from "./Administracion";
import NavItem from "./NavItem";
import { sidebar } from "../../theme";

const NavLinks = ({ drawerIsOpen }) => {
  let rout = getRuta();
  const { access } = useContext(DataContext);

  return (
    <div style={{ overflow: "hidden" }}>
      <Stack spacing={0.3} padding={1.1} justifyContent="flex-start">
        <Typography
          sx={{
            color: sidebar.sectionColor,
            fontSize: 10.5,
            fontWeight: 600,
            letterSpacing: ".7px",
            padding: "12px 10px 7px",
          }}
        >
          PRINCIPAL
        </Typography>

        <NavItem
          to={`${rout}/`}
          end
          icon={<DashboardRoundedIcon fontSize="inherit" />}
          label="Panel Principal"
        />

        {isAccess(access, "CLIENTS VER") ? (
          <NavItem
            to={`${rout}/clients`}
            icon={<GroupRoundedIcon fontSize="inherit" />}
            label="Clientes"
          />
        ) : null}

        {isAccess(access, "CREDITS VER") ? (
          <NavItem
            to={`${rout}/credits`}
            icon={<CreditCardRoundedIcon fontSize="inherit" />}
            label="Créditos"
          />
        ) : null}

        {isAccess(access, "REPORTS VER") ? (
          <NavItem
            to={`${rout}/reports`}
            icon={<DescriptionRoundedIcon fontSize="inherit" />}
            label="Reportes"
          />
        ) : null}

        {isAccess(access, "ADMON VER") ||
        isAccess(access, "SECURITY VER") ||
        isAccess(access, "CONFIG VER") ? (
          <Typography
            sx={{
              color: sidebar.sectionColor,
              fontSize: 10.5,
              fontWeight: 600,
              letterSpacing: ".7px",
              padding: "18px 10px 7px",
            }}
          >
            ADMINISTRACIÓN
          </Typography>
        ) : null}

        {isAccess(access, "ADMON VER") ? (
          <Administracion drawerIsOpen={drawerIsOpen} />
        ) : null}

        {isAccess(access, "SECURITY VER") ? (
          <Security drawerIsOpen={drawerIsOpen} />
        ) : null}

        {isAccess(access, "CONFIG VER") ? (
          <Configurations drawerIsOpen={drawerIsOpen} />
        ) : null}
      </Stack>
    </div>
  );
};

export default NavLinks;
